export default {
  apiKey: 'AIzaSyC2S2cpSa1YHpNhUYRDvA-VG0laHuTF6UI',
  authDomain: 'bill-wedding-invitation.firebaseapp.com',
  databaseURL: 'https://bill-wedding-invitation-default-rtdb.asia-southeast1.firebasedatabase.app',
  projectId: 'bill-wedding-invitation',
  storageBucket: 'bill-wedding-invitation.appspot.com',
  messagingSenderId: '73634162847',
  appId: '1:73634162847:web:f3898b81f9d2bb131b5aaa',
  measurementId: 'G-RZCKP0D9ZX'
}
